module.exports = __webpack_public_path__ + "static/media/duluth-mobile.4c45b31b.webp";